import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import JournalsPage from "./Journals/JournalsPage";
import MindfulnessProgramRouter from "./MindfulnessProgram/MindfulnessProgramRouter";

const MindfulnessFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/journals`}>
                <JournalsPage />
            </Route>
            <Route path={`${path}/mindfulness-program`}>
                <MindfulnessProgramRouter />
            </Route>
        </div>
    );
};

export default MindfulnessFeaturePage;
